import React from 'react';
import { graphql } from 'gatsby';
import { Container } from 'react-bootstrap';

import Layout from '../components/Layout';
import SEO from '../components/Seo';
import HeroImage from '../components/HeroImage';
import Search from '../components/Search';

export const query = graphql`
  query {
    backgroundImg: file(relativePath: { eq: "default-background.jpg" }) {
      childImageSharp {
        fluid(quality: 90, maxWidth: 4200) {
          ...GatsbyImageSharpFluid_withWebp
        }
      }
    }
  }
`;

const zoeken = ({ data }) => {
  return (
    <Layout pageInfo={{ pageName: 'zoeken' }}>
      <SEO title="Zoeken" />
      <HeroImage img={data.backgroundImg.childImageSharp.fluid}>
        <h1 className="text-white">Zoeken</h1>
      </HeroImage>
      <Container>
        <Search />
      </Container>
    </Layout>
  );
};

export default zoeken;
